import React from 'react';
import { NextPage } from 'next';
import { Hero, SEO } from 'templates/layout';
import { CustomMap, FormSection } from 'templates/contact-us';
import { QUOTE_ROUTE } from 'data/routes';
import { contactUsBg } from 'images/contact-us';

const ContactUs: NextPage = () => {
  return (
    <>
      <SEO
        title={'Get in touch'}
        description={'Contact us to find out more about our services and how we can help you move your freight the right way.'}
      />
      <Hero
        title={
          <>
            WE’RE JUST <br /> <span>A CLICK AWAY</span>
          </>
        }
        buttonText={'Get a Quote'}
        text={"We're here to help. Let's talk."}
        image={contactUsBg}
        link={QUOTE_ROUTE}
      />
      <FormSection />
      <CustomMap />
    </>
  );
};

export default ContactUs;
